import * as api from '../api'
import { Dispatch } from '@reduxjs/toolkit';
import { endLoading, setContactUs, setDeleteContactUs, setSingleContactUs, startLoading } from '../reducers/contactUsSlice';

export const actionFetchContactMessages = ({page}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchContactMessages({page})
        dispatch({
            type: setContactUs.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionFetchContactMessage = ({id}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const { data } = await api.fetchContactMessage({id})
        dispatch({
            type: setSingleContactUs.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionCreateContactUsMessage = ({postData}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const {data} = await api.createContactUsMessage({postData});
        dispatch({
            type: setContactUs.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}

export const actionDeleteContactUsMessage = ({id}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        const data = await api.deleteContactUsMessage({id})
        dispatch({ type: startLoading.type })
        dispatch({ 
            type: setDeleteContactUs.type,
            payload: id 
        })
        // window.location.reload();
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}